import { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import TextField from '@mui/material/TextField';
import { useInView } from 'react-intersection-observer';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import ToggleStyleSwitch from '@CommonRepresentationalDisplay/Switch/ToggleStyleSwitch';
import Snackbar from '@mui/material/Snackbar';
import ColorPicker from '@CommonFunctionalDisplay/ColorPicker';
import Alert from '@mui/material/Alert';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';
import ColorizeIcon from '@mui/icons-material/Colorize';
import BorderBlueButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderBlueButtonV2';
import EscalationMatrixForm from '@IssueConsoleForms/EscalationMatrixForm';
import AssigneeMatrixForm from '@IssueConsoleForms/AssigneeMatrixForm';
import LabelMatrixForm from '@IssueConsoleForms/LabelMatrixForm';
import PriorityCategoryMatrix from '@IssueConsoleForms/PriorityCategoryMatrix';
import DeleteKaiziqResolveConnectionForm from '@IssueConsoleForms/DeleteKaiziqResolveConnectionForm';
import { ReactComponent as DefaultFormPic } from '@Assets/form.svg';
import ProjectService from '@Helpers/URLHelpers/ProjectService';
import KaiziqResolveConnectionService from '@Helpers/URLHelpers/KaiziqResolveConnectionService';
import Autocomplete from '@mui/material/Autocomplete';
import FieldService from '@Helpers/URLHelpers/FieldService';
import FieldPageService from '@Helpers/URLHelpers/FieldPageService';
import ErrorHandler from '@Root/ErrorHandler';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import '@Partials/_SimpleStyles.scss';
import '@Partials/_ComStyles.scss';
import './SettingsPage.scss';
import ReactQuillEditor from '@Root/ReactQuill';
import { MdSettings as Settings, MdHistory as History } from 'react-icons/md';
import { MdEdit as Edit, MdDeleteForever as Delete } from 'react-icons/md';
import { MdWarning as Warning } from 'react-icons/md';
import { MdInfo as Info } from 'react-icons/md';
import { MdDescription as FormDetails, MdColorLens as Theme } from 'react-icons/md';
import { MdLabel as Labels } from 'react-icons/md';
import { MdPerson as Assignee } from 'react-icons/md';
import { MdCategory as Category, MdEscalatorWarning as Escalation } from 'react-icons/md';
import StatusSettings from './StatusSettings/StatusSettings';

export default function SettingsPage(props) {

    const [settingsViewPosition, setSettingsViewPosition] = useState(0);
    const [pageLoader, setPageLoader] = useState(true);
    const [, setAssigneeUserId] = useState(0);
    const [assigneeUser, setAssigneeUser] = useState({fullName: 'Unassigned', userName:'unassigned', id: 0});
    const [kaiziqResolveConnection, setKaiziqResolveConnection] = useState([]);
    const [formTitle, setFormTitle] = useState();
    const [imageUrl, setImageUrl] = useState('');
    const [, setUploadStatus] = useState('');
    const [, setIsValidImage] = useState(true);
    const [formFieldList, setFormFieldList] = useState([]);
    const [formFieldIdList, setFormFieldIdList] = useState([]);
    const [, setFormFieldPageList] = useState([]);
    const [, setFormFieldPageIdList] = useState([]);
    const [adminFieldList, setAdminFieldList] = useState([]);
    const [, setAdminFieldIdList] = useState([]);
    const [formBackgroundColorPickerColor, setFormBackgroundColorPickerColor] = useState();
    const [formFieldThemeBackgroundColorPickerColor, setFormFieldThemeBackgroundColorPickerColor] = useState();
    const [anchorBackgroundColorPickerMenu, setAnchorBackgroundColorPickerMenu] = useState(null);
    const [showBackgroundColorPickerMenu, setShowBackgroundColorPickerMenu] = useState(false);
    const [anchorFieldThemeBackgroundColorPickerMenu, setAnchorFieldThemeBackgroundColorPickerMenu] = useState(null);
    const [showFieldThemeBackgroundColorPickerMenu, setShowFieldThemeBackgroundColorPickerMenu] = useState(false);
    const [details, setDetails] = useState({});
    const [formSettings, setFormSettings] = useState({});
    const [isFormDetailsEdited, setIsFormDetailsEdited] = useState(false);
    const [cursor, setCursor] = useState('auto');
    const [deleteKaiziqResolveConnectionText, setDeleteKaiziqResolveConnectionText] = useState(false);
    const [showDeleteKaiziqResolveConnectionForm, setShowDeleteKaiziqResolveConnectionForm] = useState(false);
    const [formDescriptionEditor, setFormDescriptionEditor] = useState('');
    const [, setCloudSync] = useState('done');
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackBarType, setSnackBarType] = useState('success');
    const [snackBarMessage, setSnackBarMessage] = useState('');
    const [pageBackgroundObj, setPageBackgroundObj] = useState({});
    const [, setPageHeaderObj] = useState({});
    const [pageBackgroundStyle, setPageBackgroundStyle] = useState({});
    const [fieldTheme, setFieldTheme] = useState({});
    const [statusAdminFieldOptions, setStatusAdminFieldOptions] = useState([]);
    const [assigneeList, setAssigneeList] = useState([]);
    const colorList = ['#2784B9', '#40c47d', '#FDB16C', '#b06060', '#f77474', '#6080b0', '#9a60b0', '#6cb060',
            '#b0ae60', '#65412b', '#cc9963', '#e1bd83', '#60748b', '#744700', '#c8d579', '#5f8fba', '#3e6073', '#8e6dc1', '#473785',
           '#9158a9',  '#7f3f7a', '#583e84', '#073763', '#20124d', '#3d124d', '#64113f', '#780448', '#003e23', '#108764', '#1a4c3d',
            '#c8d77f', '#11888b', '#1a95bd', '#0d6c7b', '#25b56e', '#006e3d'];
    new ProjectService();
    const errorHandler = new ErrorHandler();
    const fieldService = new FieldService();
    const fieldPageService = new FieldPageService();
    const kaiziqResolveConnectionService = new KaiziqResolveConnectionService();
    let { activeUserId } = useReduxActiveUser();
    let { currentProjectId, getSimpleUsersByProjectId } = useReduxProject();
    let fieldFilter = {
        projectIdList: [currentProjectId],
        tableType: 'kaiziqResolveConnection',
        tableId: props.kaiziqResolveConnection.id,
        filterAttribute1List: []
    };
    const [, formDetailsInView] = useInView({
        triggerOnce: false,
        rootMargin: '0px 0px',
    });
    const [, formSettingsInView] = useInView({
        triggerOnce: false,
        rootMargin: '0px 0px',
    });
    const [, historyInView] = useInView({
        triggerOnce: false,
        rootMargin: '0px 0px',
    });
    const [, deleteFormInView] = useInView({
        triggerOnce: false,
        rootMargin: '0px 0px',
    });
    const className = 'issueConsole__settingsPage';

    useEffect(() => {
        renderData();
    }, [props])

    useEffect(() => {
        setTabPosition();
    }, [formDetailsInView, formSettingsInView, historyInView, deleteFormInView])

    const renderData = async () => {
        setCursor('wait');
        try {
            let userList = await renderUsersListData();
            let kaiziqResolveConnectionObj = await kaiziqResolveConnectionService.getKaiziqResolveConnectionById(props.kaiziqResolveConnection.id);
            kaiziqResolveConnectionObj = JSON.parse(kaiziqResolveConnectionObj.body);
            setKaiziqResolveConnection(kaiziqResolveConnectionObj);
            setFormTitle(kaiziqResolveConnectionObj.title);
            if(!!kaiziqResolveConnectionObj.description) {
                setFormDescriptionEditor(kaiziqResolveConnectionObj.description);
            }
            setImageUrl(kaiziqResolveConnectionObj.photo === undefined || kaiziqResolveConnectionObj.photo === null
                        ? ''
                        : URL.createObjectURL(dataURLtoFile(kaiziqResolveConnectionObj.photo)));

            let adminFilter = fieldFilter;
            adminFilter.filterAttribute1List = ['admin'];
            let filter = {
                fieldFilter: adminFilter
            }
            let adminFieldListObj = await fieldService.getListFiltered(filter);
            adminFieldListObj = JSON.parse(adminFieldListObj.body);
            setAdminFieldList(adminFieldListObj?.result);
            let statusAdminFieldObj = adminFieldListObj?.result?.find((adminField) => adminField?.title === 'status');
            let statusAdminFieldOptions = statusAdminFieldObj?.options ? JSON.parse(statusAdminFieldObj?.options) : [];
            setStatusAdminFieldOptions(statusAdminFieldOptions);
            let formFilter = fieldFilter;
            formFilter.filterAttribute1List = ['form'];
            filter = {
                fieldFilter: formFilter
            }
            let formFieldListObj = await fieldService.getListFiltered(filter);
            formFieldListObj = JSON.parse(formFieldListObj.body);
            setFormFieldList(formFieldListObj?.result);
            let fieldPageListObj = await fieldPageService.getFieldPageListByTable('kaiziqResolveConnection', kaiziqResolveConnectionObj.id);
            fieldPageListObj = JSON.parse(fieldPageListObj.body);
            setFormFieldPageList(fieldPageListObj);
            let detailsObj = JSON.parse(kaiziqResolveConnectionObj.details);
            setFormFieldPageIdList(detailsObj.fields['formPages'])
            setFormFieldIdList(detailsObj.fields['form']);
            setAdminFieldIdList(detailsObj.fields['admin']);
            setDetails(detailsObj);
            setFormSettings(detailsObj.settings);
            if(!!detailsObj?.settings?.defaults?.defaultAssignee) {
                setAssigneeUserId(detailsObj?.settings?.defaults?.defaultAssignee);
                setAssigneeUser(userList.find((user) => user.id === detailsObj?.settings?.defaults?.defaultAssignee));
            }
            setPageBackgroundObj(detailsObj?.settings?.pageBackground);
            let pageBackgroundObjValue = detailsObj?.settings?.pageBackground;
            setPageHeaderObj(detailsObj?.settings?.pageHeader);
            if(pageBackgroundObjValue.type === 'solid') {
                setPageBackgroundStyle({
                    background: pageBackgroundObjValue.color
                });
                setFormBackgroundColorPickerColor(pageBackgroundObjValue.color);
            }
            let themeObj = detailsObj?.settings?.theme;
            setFieldTheme(themeObj);
            let formFieldThemeObj = themeObj.formFieldTheme;
            let formFieldThemeBackgroundObj = formFieldThemeObj.formFieldThemeBackground;
            setFormFieldThemeBackgroundColorPickerColor(formFieldThemeBackgroundObj.color);
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
        setPageLoader(false);
    }

    const renderUsersListData = async() => {
        var loadLoops = 0, loadingError = false, errorException;
        let userList;
        for(loadLoops = 0; loadLoops < 10; loadLoops++) {
            try {
                userList = await getSimpleUsersByProjectId(currentProjectId);
                setAssigneeList([{fullName: 'Unassigned', userName:'unassigned', id: 0}, ...userList]);
                loadingError = false;
                break;
            } catch (err) {
                errorHandler.logError('User List Data', err);
                loadingError = true;
                errorException = err;
            }
        }
        if(loadLoops === 10 && loadingError === true) {
            errorHandler.handleError(errorException);
            return userList;
        }
        return userList;
    }

    const setTabPosition = () => {
        if(formDetailsInView) {
            setSettingsViewPosition(0);
        } else if(formSettingsInView) {
            setSettingsViewPosition(1);
        } else if(historyInView) {
            setSettingsViewPosition(3);
        } else if(deleteFormInView) {
            setSettingsViewPosition(4);
        }
    }

    const handleSettingsTabClick = (e, view) => {
        setSettingsViewPosition(view);
    }

    const convertFileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], { type: mime });
    }

    const handleFormNameEdit = (e) => {
        let sanitizedTitle = DOMPurify.sanitize(e.target.value);
        setFormTitle(sanitizedTitle);
        setIsFormDetailsEdited(true);
    }

	const validateImage = (file) => {
		if (file.type.split('/')[0] === 'image') {
			let sizeLimit = 1024 * 1024;
			if (file.size > sizeLimit) {
				setUploadStatus('Image size exceeded 1MB!');
				return false;
			}
			return true;
		} else {
			setUploadStatus('Upload image file!');
			return false;
		}
	};

	const validateBackgroundImage = (file) => {
		if (file.type.split('/')[0] === 'image') {
			let sizeLimit = 10 * 1024 * 1024;
			if (file.size > sizeLimit) {
				setUploadStatus('Image size exceeded 10MB!');
				return false;
			}
			return true;
		} else {
			setUploadStatus('Upload image file!');
			return false;
		}
	};

    const timeout = (delay) => {
        return new Promise( res => setTimeout(res, delay) );
    }

    const handleImageChange = () => {
        document.getElementById('fileInput').click();
    };

    const handleBackgroundImageChange = () => {
        document.getElementById('backgroundFileInput').click();
    };

    const handleDeleteTextChange = (e) => {
        let sanitizedText = DOMPurify.sanitize(e.target.value);
        setDeleteKaiziqResolveConnectionText(sanitizedText);
    }

    const handleDeleteClick = () => {
        setShowDeleteKaiziqResolveConnectionForm(!showDeleteKaiziqResolveConnectionForm);
    }

    const handleFileChange = async (e) => {
        let file = e.target.files[0];
        if (file !== undefined || file !== null) {
            if (validateImage(file)) {
                let base64File = await convertFileToBase64(file);
				setImageUrl(URL.createObjectURL(file));
                setIsFormDetailsEdited(true);
                setIsValidImage(true);
                timeout(500);
                await kaiziqResolveConnectionService.updateKaiziqResolveConnectionPhoto(kaiziqResolveConnection.id, base64File);
            } else {
                setIsValidImage(false);
            }
        }
    };

    const handleBackgroundFileChange = async (e) => {
        let file = e.target.files[0];
        if (file !== undefined || file !== null) {
            if (validateBackgroundImage(file)) {
                setCursor('wait');
                setCloudSync('syncing');
                try {
                    let pageBackgroundObjValue = pageBackgroundObj;
                    let base64File = await convertFileToBase64(file);
                    timeout(500);
                    pageBackgroundObjValue.imageURL = base64File;
                    let detailsObj = details;
                    let settingsObj = details['settings'];
                    settingsObj.pageBackground = pageBackgroundObjValue;
                    detailsObj['settings'] = settingsObj;
                    await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
                    setSnackBarMessage('Form Background Image updated successfully!');
                    setSnackBarType('success');
                    setSnackBarOpen(true);
                    await renderData();
                    setCloudSync('done');
                } catch (err) {
                    errorHandler.logError(err);
                    setCloudSync('failed');
                    setSnackBarMessage('Form Background Image failed to update!');
                    setSnackBarType('error');
                    setSnackBarOpen(true);
                }
                setCursor('auto');

            } else {
                setIsValidImage(false);
            }
        }
    };

    const handleEditFormSubmit = async (e) => {
        setCursor('wait');
        setCloudSync('syncing');
        try {
            if(isFormDetailsEdited) {
                if(formTitle !== kaiziqResolveConnection.title) {
                    await kaiziqResolveConnectionService.updateKaiziqResolveConnectionTitle(kaiziqResolveConnection.id, formTitle);
                }
                if(formDescriptionEditor !== kaiziqResolveConnection.description) {
                    await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDescription(kaiziqResolveConnection.id, formDescriptionEditor);
                }
            }
            setSnackBarMessage('Form Details updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            await props.reloadData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Form Details failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackBarOpen(false);
    };

    const toggleGenerateTicket = async(e) =>{
        setCursor('wait');
        setCloudSync('syncing');
        try {
            let detailsObj = details;
            let settingsObj = details['settings'];
            let defaultObj = settingsObj['defaults'];
            defaultObj['generateTicketId'] = !defaultObj['generateTicketId'];
            settingsObj.defaults = defaultObj;
            detailsObj.settings = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Generate Ticket updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Generate Ticket failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const handleAssigneeChange = async(e, value) =>{
        setCursor('wait');
        setCloudSync('syncing');
        try {
            let assigneeIdValue;
            if(value !== null) {
                assigneeIdValue = value.id;
                setAssigneeUserId(value.id);
                setAssigneeUser(value);
            } else {
                assigneeIdValue = 0;
                setAssigneeUserId(0);
                setAssigneeUser(assigneeList[0]);
            }
            let detailsObj = details;
            let settingsObj = details['settings'];
            let defaultObj = settingsObj['defaults'];
            defaultObj['defaultAssignee'] = assigneeIdValue;
            settingsObj.defaults = defaultObj;
            detailsObj.settings = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Default Assignee updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Default Assignee failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const toggleFullNameDefault = async(e) =>{
        setCursor('wait');
        setCloudSync('syncing');
        try {
            let detailsObj = details;
            let settingsObj = details['settings'];
            let defaultObj = settingsObj['defaults'];
            defaultObj['fullName'] = !defaultObj['fullName'];
            settingsObj.defaults = defaultObj;
            detailsObj.settings = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Full Name Default updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Full Name Default failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const toggleEmailDefault = async(e) =>{
        setCursor('wait');
        setCloudSync('syncing');
        try {
            let detailsObj = details;
            let settingsObj = details['settings'];
            let defaultObj = settingsObj['defaults'];
            defaultObj['email'] = !defaultObj['email'];
            settingsObj.defaults = defaultObj;
            detailsObj.settings = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Email Default updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Email Default failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const togglePhoneNumberDefault = async(e) =>{
        setCursor('wait');
        setCloudSync('syncing');
        try {
            let detailsObj = details;
            let settingsObj = details['settings'];
            let defaultObj = settingsObj['defaults'];
            defaultObj['phoneNumber'] = !defaultObj['phoneNumber'];
            settingsObj.defaults = defaultObj;
            detailsObj.settings = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Phone Number Default updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Phone Number Default failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const togglePriorityMatrix = async(e) =>{
        setCursor('wait');
        setCloudSync('syncing');
        try {
            let detailsObj = details;
            let settingsObj = details['settings'];
            let defaultObj = settingsObj['defaults'];
            if(!!defaultObj['priority']) {
                defaultObj['priority'] = !defaultObj['priority'];
            } else {
                defaultObj['priority'] = true
            }
            settingsObj.defaults = defaultObj;
            detailsObj.settings = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Ticket Priority updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Ticket Priority failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const toggleCategorisePriorityMatrix = async(e) =>{
        setCursor('wait');
        setCloudSync('syncing');
        try {
            let detailsObj = details;
            let settingsObj = details['settings'];
            let defaultObj = settingsObj['defaults'];
            if(!!defaultObj['categorisePriority']) {
                defaultObj['categorisePriority'] = !defaultObj['categorisePriority'];
            } else {
                defaultObj['categorisePriority'] = true
            }
            settingsObj.defaults = defaultObj;
            detailsObj.settings = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Ticket Priority Categorisation updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Ticket Priority Categorisation failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const toggleCategoriseAssigneeMatrix = async(e) =>{
        setCursor('wait');
        setCloudSync('syncing');
        try {
            let detailsObj = details;
            let settingsObj = details['settings'];
            let defaultObj = settingsObj['defaults'];
            if(!!defaultObj['categoriseAssignee']) {
                defaultObj['categoriseAssignee'] = !defaultObj['categoriseAssignee'];
            } else {
                defaultObj['categoriseAssignee'] = true
            }
            settingsObj.defaults = defaultObj;
            detailsObj.settings = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Ticket Assignee Categorisation updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Ticket Assignee Categorisation failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const toggleCategoriseLabelMatrix = async(e) =>{
        setCursor('wait');
        setCloudSync('syncing');
        try {
            let detailsObj = details;
            let settingsObj = details['settings'];
            let defaultObj = settingsObj['defaults'];
            if(!!defaultObj['categoriseLabel']) {
                defaultObj['categoriseLabel'] = !defaultObj['categoriseLabel'];
            } else {
                defaultObj['categoriseLabel'] = true
            }
            settingsObj.defaults = defaultObj;
            detailsObj.settings = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Ticket Label Categorisation updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Ticket Label Categorisation failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const handleFormBackgroundColorChange = async(color) => {
        setCursor('wait');
        setCloudSync('syncing');
        try {
            setFormBackgroundColorPickerColor(color.hex);
            pageBackgroundStyle.color = color.hex;
            let detailsObj = details;
            let settingsObj = details['settings'];
            settingsObj.pageBackground.color = color.hex;
            detailsObj['settings'] = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Form Background Color updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Form Background Color failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const handleFieldThemeBackgroundColorPickerChange = async(color) => {
        setCursor('wait');
        setCloudSync('syncing');
        try {
            setFormFieldThemeBackgroundColorPickerColor(color.hex);
            let themeObj = fieldTheme;
            themeObj['formFieldTheme']['formFieldThemeBackground'].color = color.hex;
            let detailsObj = details;
            let settingsObj = details['settings'];
            settingsObj.theme = themeObj;
            detailsObj['settings'] = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Field Background Color updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Field Background Color failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const handleFormBackgroundTypeChange = async(e) =>{
        setCursor('wait');
        setCloudSync('syncing');
        try {
            let backgroundType = e.target.value;
            let pageBackgroundObjValue = {};
            pageBackgroundObjValue.type = backgroundType;
            if(backgroundType === 'solid') {
                pageBackgroundObjValue.color = '#f7f4f2'
            } else if(backgroundType === 'image') {
                pageBackgroundObjValue.imageURL = 'N/A'
            }
            let detailsObj = details;
            let settingsObj = details['settings'];
            settingsObj.pageBackground = pageBackgroundObjValue;
            detailsObj['settings'] = settingsObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            setSnackBarMessage('Form Background type updated successfully!');
            setSnackBarType('success');
            setSnackBarOpen(true);
            await renderData();
            setCloudSync('done');
        } catch (err) {
            errorHandler.logError(err);
            setCloudSync('failed');
            setSnackBarMessage('Form Background type failed to update!');
            setSnackBarType('error');
            setSnackBarOpen(true);
        }
        setCursor('auto');
    }

    const handleBackgroundColorPickerMenu = (event) => {
        if(!showBackgroundColorPickerMenu){
            if(!!event) {
                setAnchorBackgroundColorPickerMenu(event.currentTarget);
                setShowBackgroundColorPickerMenu(true);
            }
        } else {
            setAnchorBackgroundColorPickerMenu(null);
            setShowBackgroundColorPickerMenu(false);
        }
    }

    const handleFieldThemeBackgroundColorPickerMenu = (event) => {
        if(!showFieldThemeBackgroundColorPickerMenu){
            if(!!event) {
                setAnchorFieldThemeBackgroundColorPickerMenu(event.currentTarget);
                setShowFieldThemeBackgroundColorPickerMenu(true);
            }
        } else {
            setAnchorFieldThemeBackgroundColorPickerMenu(null);
            setShowFieldThemeBackgroundColorPickerMenu(false);
        }
    }

    const getAssigneeOptionLabel = (props, option) => {
        const { key, ...optionProps } = props;
        return (
            <Box
                key={key}
                component="li"
                sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                {...optionProps}>
                <Avatar sx={{ bgcolor: colorList[option?.fullName?.charCodeAt(0) % colorList?.length] + ' !important', paddingRight: '5px !important'}}
                    className={className + '__inner__body__form__assignee__value__avatar mr-15'}>{getInitials(option?.fullName)}</Avatar>
                {option?.fullName}: {option?.userName}
            </Box>
        );
    }

    const getInitials = (string) => {
        if(!!string && string.length > 0) {
            var names = string?.split(' '),
                initials = names[0]?.substring(0, 1)?.toUpperCase();

            if (names?.length > 1) {
                initials += names[names?.length - 1]?.substring(0, 1)?.toUpperCase();
            } else {
                names = string?.split('@');
                initials = names[0]?.substring(0, 1)?.toUpperCase();

                if (names?.length > 1) {
                    initials += names[names?.length - 1]?.substring(0, 1)?.toUpperCase();
                }
            }
            return initials;
        }
        return 'N/A';
    };

    const tabData = [
        { label: 'Form Details', icon: FormDetails, value: 0 },
        { label: 'Form Settings', icon: Theme, value: 1 },
        { label: 'Status Settings', icon: Info, value: 2 },
        ...(formSettings?.defaults?.categoriseAssignee ? [{ label: 'Assignee Matrix', icon: Assignee, value: 8 }] : []),
        ...(formSettings?.defaults?.categoriseLabel ? [{ label: 'Label Matrix', icon: Labels, value: 9 }] : []),
        ...(formSettings?.defaults?.priority ? [{ label: 'Escalation Matrix', icon: Escalation, value: 6 }] : []),
        ...(formSettings?.defaults?.categorisePriority ? [{ label: 'Priority Category', icon: Category, value: 7 }] : []),
        { label: 'History', icon: History, value: 4 },
        { label: 'Delete Form', icon: Warning, value: 5 }
    ];

    return (
        <div className={className + ' component-shadow width-wfa'}
            style={{cursor: cursor}}>
            {pageLoader ? (
                <div className={`${className}__loader`}>
                    <div className={`${className}__loader__sidebar`}>
                        <Skeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: '12px', marginBottom: '1rem' }} />
                        {[...Array(6)].map((_, i) => (
                            <Skeleton key={i} variant="rectangular" width="100%" height={50} sx={{ borderRadius: '8px', marginBottom: '0.5rem' }} />
                        ))}
                    </div>
                    <div className={`${className}__loader__main`}>
                        <Skeleton variant="rectangular" width="100%" height={120} sx={{ borderRadius: '16px', marginBottom: '1.5rem' }} />
                        <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: '16px' }} />
                    </div>
                </div>
            ) : (
                <div className={`${className}__container`}>
                    {/* Header */}
                    <div className={`${className}__header`}>
                        <div className={`${className}__header__left`}>
                            <Settings className={`${className}__header__icon`} />
                            <h1 className={`${className}__header__title`}>Form Settings</h1>
                        </div>
                        <div className={`${className}__header__form`}>
                            <div className={`${className}__header__form__tag`}>{kaiziqResolveConnection?.formId}</div>
                            <div className={`${className}__header__form__name`}>{formTitle}</div>
                        </div>
                    </div>

                    {/* Content */}
                    <div className={`${className}__content`}>
                        {/* Sidebar Navigation */}
                        <div className={`${className}__sidebar`}>
                            <div className={`${className}__sidebar__nav`}>
                                {tabData.map((tab, index) => {
                                    const IconComponent = tab.icon;
                                    return (
                                        <button
                                            key={index}
                                            className={`${className}__sidebar__nav__item ${settingsViewPosition === tab.value ? 'active' : ''}`}
                                            onClick={() => handleSettingsTabClick(null, tab.value)}
                                        >
                                            <IconComponent className={`${className}__sidebar__nav__item__icon`} />
                                            <span className={`${className}__sidebar__nav__item__label`}>
                                                {tab.label}
                                            </span>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Main Content */}
                        <div className={`${className}__main`}>
                            {/* Form Details Tab */}
                            {settingsViewPosition === 0 && (
                                <div className={`${className}__details`}>
                                    <div className={`${className}__details__header`}>
                                        <h2 className={`${className}__details__title`}>Form Details</h2>
                                        <p className={`${className}__details__desc`}>
                                            Manage your form's basic information and appearance
                                        </p>
                                    </div>

                                    <div className={`${className}__details__content`}>
                                        {/* Photo Section */}
                                        <div className={`${className}__details__section`}>
                                            <div className={`${className}__details__section__header`}>
                                                <label className={`${className}__details__label`}>Form Photo</label>
                                                <span className={`${className}__details__hint`}>Upload a cover image for your form (max 1MB)</span>
                                            </div>
                                            <div className={`${className}__details__photo`}>
                                                <input
                                                    type='file'
                                                    accept='image/jpeg, image/png, image/webp'
                                                    id='fileInput'
                                                    style={{ display: 'none' }}
                                                    onChange={handleFileChange}
                                                />
                                                <div className={`${className}__details__photo__preview`}>
                                                    {imageUrl !== undefined && imageUrl !== '' ? (
                                                        <img
                                                            src={imageUrl}
                                                            className={`${className}__details__photo__preview__img`}
                                                            alt='Form Photo'/>
                                                    ) : (
                                                        <DefaultFormPic className={`${className}__details__photo__preview__placeholder`}/>
                                                    )}
                                                </div>
                                                <button 
                                                    className={`${className}__details__photo__editBtn`}
                                                    onClick={handleImageChange}
                                                >
                                                    <Edit />
                                                    Change Photo
                                                </button>
                                            </div>
                                        </div>

                                        {/* Title Section */}
                                        <div className={`${className}__details__section`}>
                                            <div className={`${className}__details__section__header`}>
                                                <label className={`${className}__details__label`}>Form Title</label>
                                                <span className={`${className}__details__hint`}>A clear, descriptive name for your form</span>
                                            </div>
                                            <TextField
                                                className={`${className}__details__input`}
                                                placeholder='Enter title ...'
                                                type='text'
                                                size='small'
                                                fullWidth
                                                required
                                                onChange={handleFormNameEdit}
                                                value={formTitle}
                                                inputProps={{ maxLength: 500 }}
                                                variant='outlined'/>
                                        </div>

                                        {/* Description Section */}
                                        <div className={`${className}__details__section`}>
                                            <div className={`${className}__details__section__header`}>
                                                <label className={`${className}__details__label`}>Description</label>
                                                <span className={`${className}__details__hint`}>Provide additional context about your form</span>
                                            </div>
                                            <div className={`${className}__details__editor`}>
                                                <ReactQuillEditor
                                                    value={formDescriptionEditor}
                                                    onChange={(e)=>{
                                                        setFormDescriptionEditor(e);
                                                        setIsFormDetailsEdited(true)
                                                    }} />
                                            </div>
                                        </div>

                                        <div className={`${className}__details__actions`}>
                                            <BorderBlueButtonV2
                                                text='Save Changes'
                                                onClick={handleEditFormSubmit}
                                                disabled={!isFormDetailsEdited || cursor === 'wait'}/>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Form Settings Tab */}
                            {settingsViewPosition === 1 && (
                                <div className={`${className}__settings`}>
                                    <div className={`${className}__settings__header`}>
                                        <h2 className={`${className}__settings__title`}>Form Settings</h2>
                                        <p className={`${className}__settings__desc`}>
                                            Customize your form's appearance and default behaviors
                                        </p>
                                    </div>

                                    <div className={`${className}__settings__content`}>
                                        {/* Background Settings */}
                                        <div className={`${className}__settings__group`}>
                                            <h3 className={`${className}__settings__group__title`}>Appearance</h3>
                                            
                                            <div className={`${className}__settings__item`}>
                                                <div className={`${className}__settings__item__left`}>
                                                    <label className={`${className}__settings__item__label`}>Background</label>
                                                    {pageBackgroundObj?.type === 'image' && (
                                                        <span className={`${className}__settings__item__hint`}>
                                                            Max Size 10MB, use 16:9 aspect ratio for best results.
                                                        </span>
                                                    )}
                                                </div>
                                                <div className={`${className}__settings__item__right`}>
                                                    <Select 
                                                        className={`${className}__settings__item__select`}
                                                        value={pageBackgroundObj?.type ?? 'solid'} 
                                                        onChange={handleFormBackgroundTypeChange}
                                                        size="small"
                                                    >
                                                        <MenuItem value='solid'>Solid color</MenuItem>
                                                        <MenuItem value='image'>Image</MenuItem>
                                                    </Select>
                                                    {pageBackgroundObj?.type === 'solid' && (
                                                        <div className={`${className}__settings__item__color`}>
                                                            <div 
                                                                className={`${className}__settings__item__color__indicator`}
                                                                style={{backgroundColor: formBackgroundColorPickerColor}}
                                                            />
                                                            <ColorizeIcon 
                                                                className={`${className}__settings__item__color__icon`}
                                                                onClick={handleBackgroundColorPickerMenu}
                                                            />
                                                        </div>
                                                    )}
                                                    {pageBackgroundObj?.type === 'image' && (
                                                        <div className={`${className}__settings__item__image`}>
                                                            <input
                                                                type='file'
                                                                accept='image/jpeg, image/png'
                                                                id='backgroundFileInput'
                                                                style={{ display: 'none' }}
                                                                onChange={handleBackgroundFileChange}
                                                            />
                                                            <Chip
                                                                label={pageBackgroundObj?.imageURL !== 'N/A' ? 'Change Image' : 'Upload Image'}
                                                                variant='outlined'
                                                                color='primary'
                                                                size='medium'
                                                                deleteIcon={<Edit className='dashboard-icon'/>}
                                                                onDelete={handleBackgroundImageChange}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className={`${className}__settings__item`}>
                                                <div className={`${className}__settings__item__left`}>
                                                    <label className={`${className}__settings__item__label`}>Form Field Background</label>
                                                    <span className={`${className}__settings__item__hint`}>Background color for form fields</span>
                                                </div>
                                                <div className={`${className}__settings__item__right`}>
                                                    <div className={`${className}__settings__item__color`}>
                                                        <div 
                                                            className={`${className}__settings__item__color__indicator`}
                                                            style={{backgroundColor: formFieldThemeBackgroundColorPickerColor}}
                                                        />
                                                        <ColorizeIcon 
                                                            className={`${className}__settings__item__color__icon`}
                                                            onClick={handleFieldThemeBackgroundColorPickerMenu}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Default Settings */}
                                        <div className={`${className}__settings__group`}>
                                            <h3 className={`${className}__settings__group__title`}>Default Settings</h3>

                                            <div className={`${className}__settings__item`}>
                                                <div className={`${className}__settings__item__left`}>
                                                    <label className={`${className}__settings__item__label`}>Auto Assign Ticket on Creation</label>
                                                    <span className={`${className}__settings__item__hint`}>Automatically assign new tickets to a user</span>
                                                </div>
                                                <div className={`${className}__settings__item__right`}>
                                                    <Autocomplete
                                                        options={assigneeList}
                                                        value={assigneeUser}
                                                        disabled={cursor === 'wait' || formSettings?.defaults?.categoriseAssignee}
                                                        getOptionLabel={(option) => option?.fullName + ' : ' + option?.userName}
                                                        renderOption = {(props, option) => getAssigneeOptionLabel(props, option)}
                                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                        onChange={handleAssigneeChange}
                                                        className={`${className}__settings__item__autocomplete`}
                                                        size="small"
                                                        renderInput={(params) => <TextField {...params} placeholder='Unassigned' variant='outlined'/>}
                                                    />
                                                </div>
                                            </div>

                                            <div className={`${className}__settings__item`}>
                                                <div className={`${className}__settings__item__left`}>
                                                    <label className={`${className}__settings__item__label`}>Generate Ticket ID</label>
                                                    <span className={`${className}__settings__item__hint`}>Auto generate a unique ID for each submission</span>
                                                </div>
                                                <div className={`${className}__settings__item__right`}>
                                                    <ToggleStyleSwitch
                                                        checked={formSettings?.defaults?.generateTicketId}
                                                        onChange={toggleGenerateTicket}/>
                                                </div>
                                            </div>

                                            <div className={`${className}__settings__item`}>
                                                <div className={`${className}__settings__item__left`}>
                                                    <label className={`${className}__settings__item__label`}>Full Name Default Field</label>
                                                    <span className={`${className}__settings__item__hint`}>Include a default full name field</span>
                                                </div>
                                                <div className={`${className}__settings__item__right`}>
                                                    <ToggleStyleSwitch
                                                        checked={formSettings?.defaults?.fullName}
                                                        onChange={toggleFullNameDefault}/>
                                                </div>
                                            </div>

                                            <div className={`${className}__settings__item`}>
                                                <div className={`${className}__settings__item__left`}>
                                                    <label className={`${className}__settings__item__label`}>Email Default Field</label>
                                                    <span className={`${className}__settings__item__hint`}>Include a default email field</span>
                                                </div>
                                                <div className={`${className}__settings__item__right`}>
                                                    <ToggleStyleSwitch
                                                        checked={formSettings?.defaults?.email}
                                                        onChange={toggleEmailDefault}/>
                                                </div>
                                            </div>

                                            <div className={`${className}__settings__item`}>
                                                <div className={`${className}__settings__item__left`}>
                                                    <label className={`${className}__settings__item__label`}>Phone Number Default Field</label>
                                                    <span className={`${className}__settings__item__hint`}>Include a default phone number field</span>
                                                </div>
                                                <div className={`${className}__settings__item__right`}>
                                                    <ToggleStyleSwitch
                                                        checked={formSettings?.defaults?.phoneNumber}
                                                        onChange={togglePhoneNumberDefault}/>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Advanced Settings */}
                                        <div className={`${className}__settings__group`}>
                                            <h3 className={`${className}__settings__group__title`}>Advanced Settings</h3>

                                            <div className={`${className}__settings__item`}>
                                                <div className={`${className}__settings__item__left`}>
                                                    <label className={`${className}__settings__item__label`}>Ticket Priority</label>
                                                    <span className={`${className}__settings__item__hint`}>Enable priority levels for tickets</span>
                                                </div>
                                                <div className={`${className}__settings__item__right`}>
                                                    <ToggleStyleSwitch
                                                        checked={formSettings?.defaults?.priority}
                                                        onChange={togglePriorityMatrix}/>
                                                    {(formSettings?.defaults?.priority ?? false) && (
                                                        <span 
                                                            className={`${className}__settings__item__link`} 
                                                            onClick={(e)=> handleSettingsTabClick(e, 6)}
                                                        >
                                                            Configure
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className={`${className}__settings__item`}>
                                                <div className={`${className}__settings__item__left`}>
                                                    <label className={`${className}__settings__item__label`}>Categorise Priority</label>
                                                    <span className={`${className}__settings__item__hint`}>Enable priority categorization</span>
                                                </div>
                                                <div className={`${className}__settings__item__right`}>
                                                    <ToggleStyleSwitch
                                                        checked={formSettings?.defaults?.categorisePriority}
                                                        onChange={toggleCategorisePriorityMatrix}/>
                                                    {(formSettings?.defaults?.categorisePriority ?? false) && (
                                                        <span 
                                                            className={`${className}__settings__item__link`} 
                                                            onClick={(e)=> handleSettingsTabClick(e, 7)}
                                                        >
                                                            Configure
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className={`${className}__settings__item`}>
                                                <div className={`${className}__settings__item__left`}>
                                                    <label className={`${className}__settings__item__label`}>Ticket Assignee Matrix</label>
                                                    <span className={`${className}__settings__item__hint`}>Auto-assign based on ticket properties</span>
                                                </div>
                                                <div className={`${className}__settings__item__right`}>
                                                    <ToggleStyleSwitch
                                                        checked={formSettings?.defaults?.categoriseAssignee}
                                                        onChange={toggleCategoriseAssigneeMatrix}/>
                                                    {(formSettings?.defaults?.categoriseAssignee ?? false) && (
                                                        <span 
                                                            className={`${className}__settings__item__link`} 
                                                            onClick={(e)=> handleSettingsTabClick(e, 8)}
                                                        >
                                                            Configure
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className={`${className}__settings__item`}>
                                                <div className={`${className}__settings__item__left`}>
                                                    <label className={`${className}__settings__item__label`}>Ticket Label Matrix</label>
                                                    <span className={`${className}__settings__item__hint`}>Auto-label based on ticket properties</span>
                                                </div>
                                                <div className={`${className}__settings__item__right`}>
                                                    <ToggleStyleSwitch
                                                        checked={formSettings?.defaults?.categoriseLabel}
                                                        onChange={toggleCategoriseLabelMatrix}/>
                                                    {(formSettings?.defaults?.categoriseLabel ?? false) && (
                                                        <span 
                                                            className={`${className}__settings__item__link`} 
                                                            onClick={(e)=> handleSettingsTabClick(e, 9)}
                                                        >
                                                            Configure
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Status Settings Tab */}
                            {settingsViewPosition === 2 && (
                                <StatusSettings
                                    initialStatuses={statusAdminFieldOptions}
                                    adminFieldList={adminFieldList}
                                    onSnackbar={(msg, type) => { setSnackBarMessage(msg); setSnackBarType(type); setSnackBarOpen(true); }}
                                    onAfterSave={renderData}
                                    setCursor={setCursor}
                                />
                            )}

                            {/* History Tab */}
                            {settingsViewPosition === 4 && (
                                <div className={`${className}__history`}>
                                    <div className={`${className}__history__header`}>
                                        <h2 className={`${className}__history__title`}>Activity History</h2>
                                        <p className={`${className}__history__desc`}>
                                            Track all activities and changes to this form
                                        </p>
                                    </div>
                                    <div className={`${className}__history__content`}>
                                        <div className={`${className}__history__comingSoon`}>
                                            <History className={`${className}__history__comingSoon__icon`} />
                                            <h3 className={`${className}__history__comingSoon__title`}>Coming Soon!</h3>
                                            <p className={`${className}__history__comingSoon__desc`}>
                                                Form activity history will be available in a future update.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Delete Tab */}
                            {settingsViewPosition === 5 && (
                                <div className={`${className}__delete`}>
                                    <div className={`${className}__delete__header`}>
                                        <h2 className={`${className}__delete__title`}>Danger Zone</h2>
                                        <p className={`${className}__delete__desc`}>
                                            Permanently delete this form and all its data
                                        </p>
                                    </div>
                                    <div className={`${className}__delete__content`}>
                                        <div className={`${className}__delete__warning`}>
                                            <Warning className={`${className}__delete__warning__icon`} />
                                            <div className={`${className}__delete__warning__content`}>
                                                <h3 className={`${className}__delete__warning__title`}>
                                                    Warning: Permanent Deletion
                                                </h3>
                                                <ul className={`${className}__delete__warning__list`}>
                                                    <li>This action cannot be undone</li>
                                                    <li>All form submissions will be permanently deleted</li>
                                                    <li>All form settings and configurations will be lost</li>
                                                    <li>This form will be immediately removed from all users</li>
                                                </ul>
                                                <p className={`${className}__delete__warning__confirm`}>
                                                    To confirm deletion, type <strong>Delete {kaiziqResolveConnection?.formId}</strong> below:
                                                </p>
                                            </div>
                                        </div>

                                        <div className={`${className}__delete__form`}>
                                            <TextField
                                                placeholder={`Delete ${kaiziqResolveConnection?.formId}`}
                                                value={deleteKaiziqResolveConnectionText}
                                                onChange={handleDeleteTextChange}
                                                variant="outlined"
                                                size="small"
                                                className={`${className}__delete__input`}
                                                fullWidth
                                            />
                                            <button
                                                className={`${className}__delete__btn`}
                                                disabled={deleteKaiziqResolveConnectionText !== (`Delete ${kaiziqResolveConnection?.formId}`)}
                                                onClick={handleDeleteClick}
                                            >
                                                <Delete />
                                                Delete Form
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Escalation Matrix Tab */}
                            {settingsViewPosition === 6 && (
                                <div className={`${className}__matrix`}>
                                    <div className={`${className}__matrix__header`}>
                                        <h2 className={`${className}__matrix__title`}>Escalation Matrix</h2>
                                        <p className={`${className}__matrix__desc`}>
                                            Configure automatic ticket escalation rules
                                        </p>
                                    </div>
                                    <div className={`${className}__matrix__content`}>
                                        <EscalationMatrixForm
                                            kaiziqResolveConnectionId={props.kaiziqResolveConnection?.id}/>
                                    </div>
                                </div>
                            )}

                            {/* Priority Category Tab */}
                            {settingsViewPosition === 7 && (
                                <div className={`${className}__matrix`}>
                                    <div className={`${className}__matrix__header`}>
                                        <h2 className={`${className}__matrix__title`}>Priority Category</h2>
                                        <p className={`${className}__matrix__desc`}>
                                            Set up priority categories for automatic classification
                                        </p>
                                    </div>
                                    <div className={`${className}__matrix__content`}>
                                        <PriorityCategoryMatrix
                                            formFieldIdList={formFieldIdList}
                                            formFieldList={formFieldList}
                                            kaiziqResolveConnectionId={props.kaiziqResolveConnection?.id}/>
                                    </div>
                                </div>
                            )}

                            {/* Assignee Matrix Tab */}
                            {settingsViewPosition === 8 && (
                                <div className={`${className}__matrix`}>
                                    <div className={`${className}__matrix__header`}>
                                        <h2 className={`${className}__matrix__title`}>Assignee Matrix</h2>
                                        <p className={`${className}__matrix__desc`}>
                                            Configure automatic assignee rules based on ticket properties
                                        </p>
                                    </div>
                                    <div className={`${className}__matrix__content`}>
                                        <AssigneeMatrixForm
                                            formFieldIdList={formFieldIdList}
                                            formFieldList={formFieldList}
                                            kaiziqResolveConnectionId={props.kaiziqResolveConnection?.id}/>
                                    </div>
                                </div>
                            )}

                            {/* Label Matrix Tab */}
                            {settingsViewPosition === 9 && (
                                <div className={`${className}__matrix`}>
                                    <div className={`${className}__matrix__header`}>
                                        <h2 className={`${className}__matrix__title`}>Label Matrix</h2>
                                        <p className={`${className}__matrix__desc`}>
                                            Configure automatic labeling rules based on ticket properties
                                        </p>
                                    </div>
                                    <div className={`${className}__matrix__content`}>
                                        <LabelMatrixForm
                                            formFieldIdList={formFieldIdList}
                                            formFieldList={formFieldList}
                                            kaiziqResolveConnectionId={props.kaiziqResolveConnection?.id}/>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {
                showDeleteKaiziqResolveConnectionForm &&
                    <DeleteKaiziqResolveConnectionForm
                        open={showDeleteKaiziqResolveConnectionForm}
                        closePopup={handleDeleteClick}
                        activeUserId={activeUserId}
                        kaiziqResolveConnection={kaiziqResolveConnection}/>
            }
            {
                showBackgroundColorPickerMenu &&
                    <ColorPicker
                        showColorMenu={showBackgroundColorPickerMenu}
                        anchorColorMenu={anchorBackgroundColorPickerMenu}
                        handleColorChange={handleFormBackgroundColorChange}
                        handleColorPickerMenu={handleBackgroundColorPickerMenu}
                        color={formBackgroundColorPickerColor}/>
            }
            {
                showFieldThemeBackgroundColorPickerMenu &&
                    <ColorPicker
                        showColorMenu={showFieldThemeBackgroundColorPickerMenu}
                        anchorColorMenu={anchorFieldThemeBackgroundColorPickerMenu}
                        handleColorChange={handleFieldThemeBackgroundColorPickerChange}
                        handleColorPickerMenu={handleFieldThemeBackgroundColorPickerMenu}
                        color={formFieldThemeBackgroundColorPickerColor}/>
            }
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                open={snackBarOpen}
                autoHideDuration={5000}
                onClose={handleSnackBarClose}>
                <Alert
                    onClose={handleSnackBarClose}
                    severity={snackBarType}
                    variant='filled'
                    sx={{ width: '100%' }}>
                    {snackBarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
}

